import CardCommon from '@/pages/opinion/components/CardCommon';
import React, { useMemo, useState } from 'react';
import { Col } from 'tea-component';
import BarChart from '../ChartComponent/BarChart';
import LineChart from '../ChartComponent/LineChart';
import useLanguage from '@/pages/opinion/hooks/useLanguage';
import {
  percentageFormat,
  reviewsFormat,
  sentimentFormat,
} from '@/pages/opinion/utils/value';
import { barIcon, lineIcon } from '@/pages/opinion/constants/chart';

export default function BottomAccountEngagement({
  barDataMap,
  lineDataMap,
  loading,
  commonParams,
  xAxisList,
}: any) {
  const [filterValue, setFilterValue] = useState('mentions');
  const [operation, setOperation] = useState<string>('bar');

  const nonNegativeChartData = useMemo(() => {
    const dataInfo: any = operation === 'bar' ? barDataMap : lineDataMap;
    return dataInfo?.non_negative_ratio;
  }, [barDataMap, lineDataMap, operation]);
  const { formatMessage, formatOptionsMessage } = useLanguage();
  const lineChartData = useMemo(() => {
    return lineDataMap[filterValue];
  }, [lineDataMap, filterValue]);

  return (
    <>
      <Col span={12}>
        <CardCommon
          title={formatMessage({ id: 'Timeline of Mentions & Sentiment' })}
          loading={loading}
          loadingHeight={300}
          filterClassName="mentions-sentiment-tab"
          filters={formatOptionsMessage([
            { value: 'mentions', text: 'Mentions' },
            { value: 'avg_sentiment', text: 'Sentiment' },
          ])}
          handleFilterOnChange={(value: string) => {
            setFilterValue(value);
          }}
        >
          <LineChart
            xAxisList={xAxisList}
            data={lineChartData}
            height={300}
            yAxisOptions={
              filterValue === 'avg_sentiment' ? { max: 5, min: 0 } : {}
            }
            title={filterValue === 'avg_sentiment' ? 'Sentiment' : 'Mentions'}
            hasShare={filterValue !== 'avg_sentiment'}
            formatValue={
              filterValue === 'avg_sentiment' ? sentimentFormat : reviewsFormat
            }
            filter={commonParams}
          ></LineChart>
        </CardCommon>
      </Col>
      <Col span={12}>
        <CardCommon
          title={formatMessage({ id: 'Non Negative%' })}
          loading={loading}
          loadingHeight={320}
          defaultOperation={operation}
          handleOperationsOnClick={(item: any) => {
            setOperation(item.symbol);
          }}
          operations={[barIcon, lineIcon]}
        >
          {operation === 'bar' ? (
            <BarChart
              xAxisList={xAxisList}
              data={nonNegativeChartData}
              chartType={operation}
              height={350}
              title="Non Negative%"
              showName={false}
              filter={commonParams}
              formatValue={(value: number) => percentageFormat(value * 100)}
            ></BarChart>
          ) : (
            <LineChart
              xAxisList={xAxisList}
              data={nonNegativeChartData}
              filter={commonParams}
              height={350}
              hasShare={false}
              title="Non Negative%"
              formatValue={(value: number) => percentageFormat(value * 100)}
            ></LineChart>
          )}
        </CardCommon>
      </Col>
    </>
  );
}
